var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "addtime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "32 18 32 32 42 42"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M5.02,21.345A29.018,29.018,0,1,1,3,32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.022 4.959 5 21.351 20.689 15.897"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtime);
export default __webpack_public_path__ + "static/media/addtime.28e4b2e6b9b0524171b22a49c9ff4096.svg";
export { ForwardRef as ReactComponent };